 <div class="card bg-accent-lighter row">
	@if(hasImage){
		<img class="horizontal-image" [src]="url ?? localUrl "
				[ngClass]="{'rounded': rounded && aspectRatio === 1}">
	}
	@if(!hasImage){
		<img class="horizontal-image" src="../../../assets/images/undefined-image.png" alt="unknown image">
	}
	<div class="course-info-container">
		<h2 class="title">{{'general.upload_image' | translateWithKeys}}</h2>
		<div>
			<span class="description">{{'general.recommended_size' | translateWithKeys}}: 1920 x 1080px</span>
			<br>
			<span class="description">{{'general.weight' | translateWithKeys}}:  {{'general.file_weight_recommendation' | translateWithKeys}}</span>
			<br>
			<span class="description">{{'general.format' | translateWithKeys}}:  {{'general.recommended_format' | translateWithKeys}}</span>
		</div>

		<div class="button-container row">
			<input #coverImage hidden type="file" (change)="fileChangeEvent($event)" (click)="coverImage.value = ''" name="coverImage" accept="image/jpeg, image/jpg, image/png">
			@if(!hasImage){
				<div class="container-upload">
					<button class="view-btn btn-border border-accent" mat-button  (click)="coverImage.click()"><mat-icon class="icon" svgIcon="upload_outlined_black"></mat-icon>{{'general.upload' | translateWithKeys}}</button>
					@if(showError){
						<div class="container-error bg-warn-lighter">
							<mat-icon color="warn" svgIcon="warning"></mat-icon><span class="text-warn">{{'course-creation.error_image' | translateWithKeys}}</span>
						</div>
					}
				</div>

			}
			@if(hasImage){
				<button class="view-btn btn-border border-accent" mat-flat-button (click)="removeImage()">{{'general.remove' | translateWithKeys}}</button>
				<button class="view-btn bg-primary-darker text-accent-lighter" mat-flat-button  (click)="coverImage.click()">{{'general.replace' | translateWithKeys}}</button>
			}
		</div>
	</div>
</div>



<ng-template #cropper>
    <div fxLayout="column" class="cropper-modal">
		<h4>Crop Image</h4>

		 <image-cropper *ngIf="!freeCropper && imageChangedEvent !== null" class="cropped-img-container"
			[imageChangedEvent]="imageChangedEvent"
			[aspectRatio]="aspectRatio"
			[roundCropper]="rounded && aspectRatio === 1"
			format="png"
			(imageCropped)="imageCropped($event)"
		></image-cropper>

		<image-cropper *ngIf="freeCropper && imageChangedEvent !== null" class="cropped-img-container"
			[imageChangedEvent]="imageChangedEvent"
			[aspectRatio]="aspectRatio"
			[roundCropper]="rounded && aspectRatio === 1"
			format="png"
			(imageCropped)="imageCropped($event)"
		></image-cropper>

    </div>
	<div class="btn-modal-container">
		<button class="view-btn btn-border border-accent" mat-flat-button (click)="removeImage()">{{'general.cancel' | translateWithKeys}}</button>
		<button class="view-btn bg-primary-darker text-accent-lighter" mat-flat-button color="primary" [disabled]="disabled" data-testid="thumbnail-cropper-save-btn" (click)="closeModal()" >{{'general.save' | translateWithKeys}}</button>
	</div>
  </ng-template>
